module.exports = __webpack_public_path__ + "static/love-mondays-506523b8c479810fea78fc5159820983.png";